//通知PC WAP公用数据
import { $subscriber, ck } from "fire-wind-water";
import ws from "../services/webinar";

export function buildNoticeMethod(otherMethods) {
  return Object.assign(
    {
      getNotifications(webinar) {
        let self = this;
        let params = {
          page: 1,
          limit: 10000,
          sort: "updated_at",
          order: "desc",
          webinarId: webinar.webinarId
        };
        ws.getNotices(params).then(data => {
          //如果有多条加入（join）通知只显示第一条 有可能是bug但是目前就是这样 已经和需求沟通
          if (data.docs.length > 0) {
            self.joinMessage = data.docs[0];

            self.notify(self.joinMessage, "initNotifications");

            // let messageList = ck.cookie("joinMessage" + webinar.webinarId);
            // if (
            //   !messageList ||
            //   (messageList.length > 0 &&
            //     messageList.indexOf(self.joinMessage._id) < 0)
            // ) {
            //   //不包含就发消息
            //   self.notify(self.joinMessage, 'initNotifications');
            //   if (!messageList) {
            //     messageList = [];
            //   }
            //   messageList.push(self.joinMessage._id);
            //   ck.cookie("joinMessage" + webinar.webinarId, messageList);
            // }
          }
        });
      }
    },
    otherMethods
  );
}

export function mounted(model) {
  let self = model;
  self;
  delete
  $subscriber.subscribe("onNotification", function(data) {

    if(data.notification.content.indexOf('|&|')>-1){
    }else {
      self.notify(data.notification, "onNotification");
    }

  });
  $subscriber.subscribe("onNotificationDelete", function(data) {
    self.notify(data, "onNotificationDelete");
  });
  $subscriber.subscribe("webinarInfo", function(data) {
    self.getNotifications(data); //获取所有通知
  });
}
